import React, { useState, useEffect } from 'react';
import { Form, Modal, Label } from 'semantic-ui-react';
import '../localization/config';
import { useTranslation } from 'react-i18next';
import { FlexRow } from '../layouts';

export interface ISetRepositoryModal {
  open: boolean;
  currentUrl: string | undefined;

  onSubmit(_url: string): void;
  onCancel(): void;
}

const SetRepositoryModal = (props: ISetRepositoryModal) => {
  const { currentUrl, open, onSubmit, onCancel } = props;
  const [url, setUrl] = useState<string | undefined>(currentUrl);

  const { t } = useTranslation();

  useEffect(() => {
    setUrl(currentUrl);
  }, [currentUrl]);

  const handleChange = (e: any) => {
    setUrl(e.target.value);
  };

  const isValid = () => {
    if (!url) {
      return false;
    }

    if (url === currentUrl) {
      return false;
    }

    const regex = new RegExp(
      '((git|ssh|http(s)?)|(git@[\\w\\.]+))(:(//)?)([\\w\\.@\\:/\\-~]+)(\\.git)(/)?'
    );
    return regex.test(url);
  };
  return (
    <Modal open={open} as={Form} style={{ width: 600 }}>
      <>
        <Modal.Header>{t('settings.setRemoteRepository')}</Modal.Header>
        <Modal.Content>
          <Form.Field>
            <input
              type="text"
              placeholder={t('settings.url')}
              value={url}
              onChange={handleChange}
            />
            <Label pointing color={(isValid() || !url) ? undefined : 'red'}>{t('settings.urlHelperText')}</Label>
          </Form.Field>
          <FlexRow fullWidth right>
            <Form.Button onClick={onCancel} color="grey">
              {t('general.cancel')}
            </Form.Button>
            <Form.Button
              onClick={() => onSubmit(url as string)}
              color="green"
              disabled={!isValid()}
            >
              {t('general.save')}
            </Form.Button>
          </FlexRow>
        </Modal.Content>
      </>
    </Modal>
  );
};

export default SetRepositoryModal;
